import React, { useEffect, useState, useContext } from "react";

import {
  Grid,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";
import MaskService from "../../../../utils/mask/maskService";

import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import useIntermediadorController from "../controllers/IntermediadorController";
import { IntermediadorContext } from "../contexts/IntermediadorContext";
import { HeaderAccordion } from "../styles/Intermediador";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

let temporizer = null;

const AccordionIntermediadoresGeral = ({ ...props }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const {
    listTabelaPrecoData,
    listLocaisEstoque,
    handleNumInscricao,
    handleChangeOpenAcordion,
  } = useIntermediadorController();

  const {
    intermediadorCnpjNew,
    setIntermediadorCnpjNew,
    intermediadorAtivoNew,
    setIntermediadorAtivoNew,
    isIntermediadorNew,
    setIsIntermediadorNew,
    intermediadorRazaoNew,
    setIntermediadorRazaoNew,
    identificadorUsuarioNew,
    setIdentificadorUsuarioNew,
    intermediadorDescricaoNew,
    setIntermediadorDescricaoNew,
    tabelaPrecosIdNew,
    setTabelaPrecosIdNew,
    tabelaPrecosData,
    setTabelaPrecosData,
    estoques,
    setEstoques,
    estoquesIdNew,
    setEstoquesIdNew,
    expanded,
    geralErrors,
  } = useContext(IntermediadorContext);

  const handleInputUser = (e) => {
    let newInput = e.target.value;
    let mask = newInput.length > 14 ? "cnpj" : "cpf";
    let updatedInput = MaskService.toMask(mask, newInput);
    let oldValue = MaskService.toMask(mask, intermediadorCnpjNew);
    setIntermediadorCnpjNew(updatedInput);
    if (updatedInput === oldValue) return;

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleNumInscricao(updatedInput);
    }, 1800);
  };

  const [loading, setLoading] = useState({});

  useEffect(() => {
    // Request locais de estoques
    (async () => {
      try {
        setLoading((prev) => ({ ...prev, estoquesIdNew: true }));

        const buscaEstoque = await listLocaisEstoque();
        setEstoques(buscaEstoque || []);
      } catch (error) {
        console.error("error useEffect IntermediadorFormDialog", error);
      } finally {
        setLoading((prev) => ({ ...prev, estoquesIdNew: false }));
      }
    })();
  }, [listLocaisEstoque, setEstoques, setLoading]);

  useEffect(() => {
    // request tabelas de preço cadastradas
    (async () => {
      try {
        if (queryParams.paramutilizatabelaprecos === "SIM") {
          setLoading((prev) => ({ ...prev, tabelaPrecosIdNew: true }));

          const retorno = await listTabelaPrecoData();
          setTabelaPrecosData(retorno || []);
        }
      } catch (error) {
        console.error("error useEffect IntermediadorFormDialog", error);
      } finally {
        setLoading((prev) => ({ ...prev, tabelaPrecosIdNew: false }));
      }
    })();
  }, [
    listTabelaPrecoData,
    queryParams.paramutilizatabelaprecos,
    setTabelaPrecosData,
    setLoading,
  ]);

  return (
    <Grid item xs={12}>
      <Accordion
        expanded={expanded?.general || false}
        onChange={() => handleChangeOpenAcordion("general")}
      >
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <HeaderAccordion>
            <Grid container>
              <Grid item xs={12}>
                <Chip
                  bgcolor="primary"
                  textcolor="white"
                  label="DADOS GERAIS"
                />
              </Grid>
            </Grid>
          </HeaderAccordion>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="intermediadorCnpjNew"
                label="CNPJ Intermediador*"
                value={intermediadorCnpjNew}
                onChange={(e) => handleInputUser(e)}
                helperText={geralErrors.intermediadorCnpjNew || ""}
                error={geralErrors.intermediadorCnpjNew ? true : false}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="intermediadorRazaoNew"
                label="Razão social*"
                value={intermediadorRazaoNew.slice(0, 60)}
                setValue={setIntermediadorRazaoNew}
                helperText={geralErrors.intermediadorRazaoNew || ""}
                error={geralErrors.intermediadorRazaoNew ? true : false}
              />
            </Grid>

            <Grid item lg={4} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="identificadorUsuarioNew"
                label="Identificador do usuário*"
                value={identificadorUsuarioNew.slice(0, 100)}
                setValue={setIdentificadorUsuarioNew}
                helperText={geralErrors.identificadorUsuarioNew || ""}
                error={geralErrors.identificadorUsuarioNew ? true : false}
              />
            </Grid>

            <Grid item lg={6} md={6} sm={6} xs={12}>
              <TextFieldErp
                id="intermediadorDescricaoNew"
                label="Descrição Resumida*"
                value={intermediadorDescricaoNew.slice(0, 255)}
                setValue={setIntermediadorDescricaoNew}
                helperText={geralErrors.intermediadorDescricaoNew || ""}
                error={geralErrors.intermediadorDescricaoNew ? true : false}
              />
            </Grid>

            <Grid item md={6} sm={12} xs={12}>
              <SelectErp
                multiple
                loading={loading.estoquesIdNew}
                label="Locais de Estoque"
                value={estoquesIdNew}
                onChange={setEstoquesIdNew}
                optionsList={estoques}
                descriptionField="descricao"
              />
            </Grid>

            {queryParams.paramutilizatabelaprecos === "SIM" && (
              <Grid item md={6} sm={12} xs={12}>
                <SelectErp
                  loading={loading.tabelaPrecosIdNew || loading.data}
                  helperText={geralErrors.tabelaPrecosIdNew || ""}
                  error={geralErrors.tabelaPrecosIdNew ? true : false}
                  label="Tabela de Preço"
                  value={tabelaPrecosIdNew}
                  onChange={setTabelaPrecosIdNew}
                  optionsList={tabelaPrecosData}
                  descriptionField="descricao"
                />
              </Grid>
            )}

            <Grid item container>
              <Grid item md={1} sm={6} xs={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={intermediadorAtivoNew}
                      onChange={() =>
                        setIntermediadorAtivoNew((current) => !current)
                      }
                      color="primary"
                    />
                  }
                  label="Ativo"
                  labelPlacement="end"
                />
              </Grid>

              <Grid item md={1} sm={6} xs={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isIntermediadorNew}
                      onChange={() =>
                        setIsIntermediadorNew((current) => !current)
                      }
                      color="primary"
                    />
                  }
                  label="Intermediador"
                  labelPlacement="end"
                />
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default AccordionIntermediadoresGeral;
